/**
 * 网络诊间相关路由
 */
export default [
  /**
   * 网络诊间首页
   */
  {
    path: '/online',
    component: () => import('../pages/online/index')
  },

  /**
   * 填写就诊资料
   * query
   * **** id 挂号单编号
   * **** hzid 平台患者id
   */
  {
    path: '/online/add',
    component: () => import('../pages/online/add-information.vue')
  },

  /**
   * 预约成功-填写资料
   * query
   * **** hzid 平台患者id
   */
  {
    path: '/online/succeed',
    component: () => import('../pages/online/online-succeed')
  },
  //成功页提示下载app
  {
    path: '/online/order/succeed',
    component: () => import('../pages/online/order-succeed')
  },
  /**
   * 填写资料成功
   */
  {
    path: '/online/add/succeed',
    component: () => import('../pages/online/add-succeed')
  },
  /**
   * 搜索页
   */
  {
    path: '/online/search',
    component: () => import('../pages/online/online-search')
  },
  /**
   * 网络诊间候诊区
   */
  {
    path: '/online/quick/queue',
    component: () => import('../pages/online/quick/queue')
  }
]



// WEBPACK FOOTER //
// ./src/router/online.js